import { useState, useEffect } from 'react';
import { SendMessage } from './App.js';
import icobackblue from './img/ico-backblue.svg';

import icobackred from './img/ico-backred.svg';
import strings from './strings.js';
import { v4 as uuid } from 'uuid';
import localForage from "localforage";
import { toast } from 'react-toastify';

const API_URL = "https://www.starboxkod.com/api";

const SelectingYesNoCard = ({ song, onClick, stateVer, tableNo, lang, cookieFavs, setCookieFavs }) => {
    const [selectingKey, setSelectingKey] = useState(0);
    const [selectingVocal, setSelectingVocal] = useState(false);
    const [selectingRec, setSelectingRec] = useState(false);
    const [selectingRecUuid, setSelectingRecUuid] = useState("");
    const [selectingFav, setSelectingFav] = useState(cookieFavs.some(e => e.song_num === song.song_num));

    function weChatPlayVideo() {
        if (window.WeixinJSBridge) {
            window.WeixinJSBridge.invoke('getNetworkType', {}, function () {
                const videoElement = document.getElementById('bg-video');
                videoElement?.play();
            });
        }
    }

    useEffect(() => {
        weChatPlayVideo();
    }, []);

    return (
        <div className="LMAOselecting">
            <div className="mui-overlay" onClick={(e) => { e.preventDefault(); /* onClick() */ }}></div>
            <div className="actions-sheet" onClick={(e) => { e.preventDefault(); e.stopPropagation(); e.nativeEvent.stopImmediatePropagation(); }}>
                <div className="preview">
                    <video
                        id="bg-video"
                        playsInline={true}
                        webkit-playsinline="true"
                        x5-playsinline="true"
                        x5-video-player-type="h5"
                        x5-video-orientation="landscape|portrait"
                        x5-video-player-fullscreen="true"
                        className="previewActual"
                        src={`https://starboxkod.com/${song.server_id}/${song.rel_path?.slice(0, -2)}p4`} autoPlay loop muted></video>
                </div>

                <div className="songcontrols">
                    <div className="songinfo">
                        <div className="actions-sheetSongNum">
                            {song.song_num}
                        </div>
                        <div className="actions-sheetName">
                            {song.song_name}
                        </div>
                        <svg className="actions-sheetNotFavourites"
                            xmlns="http://www.w3.org/2000/svg"
                            width="35" height="24" viewBox="-2 -2 50 50"
                            version="1.1"
                            onClick={(e) => {
                                e.preventDefault();
                                if (cookieFavs.some(e => e.song_num === song.song_num)) {
                                    setCookieFavs(cookieFavs.filter(color => color.song_num !== song.song_num))
                                } else {
                                    setCookieFavs([...cookieFavs, song])
                                }
                            }}
                        >
                            <path d="M 7.212 1.106 C 3.228 2.282, 0.009 7.118, 0.004 11.934 C -0.002 17.533, 3.457 22.937, 13.488 33 L 22.959 42.500 33.050 32.500 C 43.478 22.167, 45.989 18.738, 46.015 14.800 C 46.028 12.948, 46.220 12.792, 47 14 C 47.699 15.081, 47.941 14.243, 47.866 11 C 47.772 6.896, 47.696 6.764, 47 9.500 C 46.284 12.314, 46.229 12.344, 46.118 9.973 C 45.847 4.180, 39.118 -0.537, 32.812 0.647 C 30.990 0.989, 28.027 2.364, 26.226 3.703 L 22.953 6.138 19.900 3.569 C 18.220 2.156, 16.319 0.994, 15.673 0.986 C 15.028 0.979, 13.600 0.784, 12.500 0.554 C 11.400 0.324, 9.020 0.572, 7.212 1.106 M 0.272 12 C 0.272 14.475, 0.467 15.488, 0.706 14.250 C 0.944 13.012, 0.944 10.988, 0.706 9.750 C 0.467 8.512, 0.272 9.525, 0.272 12"
                                stroke="var(--heart-fill)" 
                                strokeWidth="4px" 
                                fill={cookieFavs.some(e => e.song_num === song.song_num) ? "var(--heart-fill)" : "none"} 
                                fillRule="evenodd" />
                        </svg>

                        <div className="actions-sheetSinger">
                            {song.singer}
                        </div>
                    </div>
                </div>

                {(stateVer === "dating" || stateVer === "danji") && (
                    <div className="bottom-buttons">
                        <div className="add-song-container">
                            <a className="ActionPanelnorec-btn chevron"
                                onClick={(e) => { e.preventDefault(); setSelectingKey(selectingKey === -6 ? selectingKey : selectingKey - 1); }}
                                style={{ color: selectingKey === -6 ? "var(--action-icon-inactive)" : "var(--action-icon-active)" }}
                            >
                                ▼&#xFE0E;
                            </a>
                            <a className="ActionPanelmid-btn" onClick={(e) => e.preventDefault()}>
                                {(selectingKey < 1 ? "" : "+")}{selectingKey}
                            </a>
                            <a className="ActionPanelrec-btn chevron"
                                onClick={(e) => { e.preventDefault(); setSelectingKey(selectingKey === 6 ? selectingKey : selectingKey + 1); }}
                                style={{ color: selectingKey === 6 ? "var(--action-icon-inactive)" : "var(--action-icon-active)" }}
                            >
                                ▲&#xFE0E;
                            </a>

                            <a className={`ActionPanelnorec-btn ${!selectingVocal ? 'selected' : ''}`}
                                onClick={(e) => { e.preventDefault(); setSelectingVocal(false); }}
                            >
                                {lang ? strings.cn.acc : strings.en.acc}
                            </a>
                            <a className={`ActionPanelrec-btn ${selectingVocal ? 'selected' : ''}`}
                                onClick={(e) => { e.preventDefault(); setSelectingVocal(true); }}
                            >
                                {lang ? strings.cn.ori : strings.en.ori}
                            </a>
                        </div>
                    </div>
                )}

                <div className="add-song-container">
                    <a className="add-song-container-Back" onClick={(e) => { e.preventDefault(); onClick(); }}>
                        <img src={document.body.getAttribute('data-skin') === '1' ? icobackred :icobackblue} alt="back" />
                    </a>
                    {(stateVer === "dating" || stateVer === "danji") && (
                        <>
                            <a className={`ActionPanelnorec-btn ${!selectingRec ? 'selected' : ''}`}
                                onClick={(e) => { e.preventDefault(); setSelectingRec(false); setSelectingRecUuid(""); }}
                            >
                                {lang ? strings.cn.noRec : strings.en.noRec}
                            </a>
                            <a className={`ActionPanelrec-btn ${selectingRec ? 'selected' : ''}`}
                                onClick={(e) => { e.preventDefault(); setSelectingRec(true); setSelectingRecUuid(uuid()); }}
                            >
                                {lang ? strings.cn.recd : strings.en.recd}
                            </a>
                        </>
                    )}
                    <a className="ActionPaneladdsong-btn"
                        onClick={(e) => {
                            e.preventDefault();
                            SendMessage(`[{"type":"TABLE_CLIENT_ADD_SONG", "tableId":"t${tableNo}", "userId":"${JSON.parse(localStorage.getItem("sn"))}", "songcode":"${song.song_num}","vocal":${selectingVocal},"musicKey":${selectingKey},"rec":${selectingRec}, "song_name":"${song.song_name}", "singer":"${song.singer}", "language":"${song.language}", "audio_track":${song.audio_track}, "server_id":"${song.server_id}", "rel_path":"${song.rel_path}"}]`);
                            onClick();

                            toast.success(lang ? strings.cn.addSongSuccess : strings.en.addSongSuccess, {
                                position: "top-center",
                                autoClose: 1000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: false,
                                draggable: true,
                                theme: "light",
                                icon: false,
                            });
                        }}
                    >
                        {lang ? strings.cn.addSong : strings.en.addSong}
                    </a>
                </div>
            </div>
        </div>
    );
}

export default SelectingYesNoCard;